export default "__VITE_ASSET__CYZ5Xm70__"